import {
  type AllergenMapping,
  type TaxonomyAllergen,
  type TaxonomyPreference,
} from "api-types";

import React, { createContext, useContext } from "react";

import type { Tag } from "@dashboard/types";

/**
 * Context for taxonomy related data.
 *
 * Contains taxonomy data for the current language context,
 * used for rending allergens and dishes across various parts of the app.
 */
type TaxonomyCtx = {
  allergenMappings: AllergenMapping[];
  taxonomyAllergens: TaxonomyAllergen[];
  taxonomyPreferences: TaxonomyPreference[];
  tags: Tag[];
};

const TaxonomyContext = createContext<TaxonomyCtx>({} as TaxonomyCtx);

export const TaxonomyProvider = ({
  children,
  allergenMappings,
  taxonomyAllergens,
  taxonomyPreferences,
  tags,
}: {
  children: React.ReactNode;
  allergenMappings: AllergenMapping[];
  taxonomyAllergens: TaxonomyAllergen[];
  taxonomyPreferences: TaxonomyPreference[];
  tags: Tag[];
}) => {
  return (
    <TaxonomyContext.Provider
      value={{
        allergenMappings,
        taxonomyAllergens,
        taxonomyPreferences,
        tags,
      }}
    >
      {children}
    </TaxonomyContext.Provider>
  );
};

export const useTaxonomyCtx: () => TaxonomyCtx = () =>
  useContext(TaxonomyContext);
